import angular from 'angular';
import userGroupMemberships from 'user/components/group-memberships/user-group-memberships-module';
import retailerGroupsExistingUserField from 'retailer-groups/components/existing-user-field/retailer-groups-existing-user-field-module';
import AccountDetailsComponent from './account-details-component';

export default angular
  .module('account-details', [
    userGroupMemberships.name,
    retailerGroupsExistingUserField.name,
  ])
  .component('accountDetails', new AccountDetailsComponent());



// WEBPACK FOOTER //
// ./src/modules/user/components/edit-account/components/account-details/account-details-module.js